module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-390.6635fff.woff2";